import { render, staticRenderFns } from "./VTrashBin.vue?vue&type=template&id=1a64d3a8&"
import script from "./VTrashBin.vue?vue&type=script&lang=js&"
export * from "./VTrashBin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports